<template>
  <div>
    <vs-card class="my-5">
      <div slot="header">
        <h3>Dados do Condutor</h3>
      </div>
      <formularioDadosCondutor
        :formulario="form"
        :dadosCondutor="dadosCondutor"
        :dadosEvento="dadosEvento"
        @formAlterado="alteraFormularioDadosCondutor($event)"
      >
      </formularioDadosCondutor>

      <formularioDadosCondutorFotos
        :dadosAssociado="dadosAssociado"
        :fotosCondutor="fotosCondutor"
        @formAlterado="alteraFormularioDadosCondutorFotos($event)"
      >
      </formularioDadosCondutorFotos>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Envolvidos</h3>
      </div>

      <formularioListaEnvolvidos
        :envolvidos="dadosEnvolvidos"
        @formAlterado="alteraFormularioDadosEnvolvidos($event)"
      >
      </formularioListaEnvolvidos>
    </vs-card>
    <div class="vx-row divider mt-4 mb-2"></div>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Testemunhas</h3>
      </div>
      <formularioListaTestemunhas
        :testemunhas="dadosTestemunhas"
        @formAlterado="alteraFormularioDadosTestemunhas($event)"
      >
      </formularioListaTestemunhas>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Partes Danificadas</h3>
      </div>

      <formularioListaPartesDanificadas
        :partesDanificadas="partesDanificadas"
        :outrasPartesDanificadas="outrasPartesDanificadas"
        @formAlterado="alteraFormularioPartesDanificadas($event)"
      >
      </formularioListaPartesDanificadas>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Croqui</h3>
      </div>
      <croqui
        :croqui="croqui"
        :envolvidos="envolvidosCroqui"
        :evento="dadosEvento"
      >
      </croqui>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Checklist</h3>
      </div>
      <formularioChecklistColisao
        :checklist="checklistColisao"
        @formAlterado="alteraFormularioChecklistColisao($event)"
      ></formularioChecklistColisao>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Fotos do Veículo</h3>
      </div>

      <formularioDadosVeiculoFotos
        :dadosAssociado="dadosAssociado"
        :fotosVeiculo="fotosVeiculo"
        @formAlterado="alteraFormularioDadosVeiculoFotos($event)"
      >
      </formularioDadosVeiculoFotos>
    </vs-card>

    <vs-card class="my-5">
      <div slot="header">
        <h3>Termos Assinados</h3>
      </div>
      <formularioListaTermosAssinados />
    </vs-card>
  </div>
</template>

<script>
import locale from '../../../locale';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import moment from 'moment';
import formularioDadosCondutor from './formDadosCondutorEvento';
import formularioListaEnvolvidos from './formListaEnvolvidos';
import formularioListaTestemunhas from './formListaTestemunhas';
import formularioListaPartesDanificadas from './formListaPartesDanificadas';
import formularioChecklistColisao from './formChecklistColisao';
import formularioDadosCondutorFotos from './formDadosCondutorFotos';
import formularioDadosVeiculoFotos from './formDadosVeiculoFotos';
import formularioListaTermosAssinados from './formListaTermosAssinados';
import croqui from './croquiEvento';

export default {
  props: ['dadosEvento', 'formulario', 'tiposEvento', 'tiposColisao', 'status'],
  watch: {
    dadosEvento() {
      this.preencheForm();
    },
  },
  components: {
    formularioDadosCondutor,
    formularioListaEnvolvidos,
    formularioListaTestemunhas,
    formularioListaPartesDanificadas,
    formularioChecklistColisao,
    formularioDadosCondutorFotos,
    formularioDadosVeiculoFotos,
    formularioListaTermosAssinados,
    croqui,
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'd/m/Y H:i',
        locale: Portuguese,
        time_24hr: true,
      },
      dadosCondutor: {},
      dadosAssociado: {},
      fotosCondutor: [],
      fotosVeiculo: [],
      dadosEnvolvidos: null,
      dadosTestemunhas: null,
      partesDanificadas: null,
      outrasPartesDanificadas: null,
      checklistColisao: null,
      croqui: null,
      envolvidosCroqui: [],
      form: {
        idEvento: null,
        dadosCondutor: {},
        fotosCondutor: [],
        fotosVeiculo: [],
        dadosEnvolvidos: null,
        dadosTestemunhas: null,
        outrasPartesDanificadas: null,
        checklistColisao: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    preencheForm() {
      if (this.formulario.preAberturaAssociado.idEvento) {
        this.form = this.formulario.preAberturaAssociado;
        this.dadosCondutor = this.formulario.preAberturaAssociado.dadosCondutor;
        this.dadosEnvolvidos =
          this.formulario.preAberturaAssociado.dadosEnvolvidos;
        this.dadosTestemunhas =
          this.formulario.preAberturaAssociado.dadosTestemunhas;
        this.partesDanificadas =
          this.formulario.preAberturaAssociado.partesDanificadas;
        this.outrasPartesDanificadas =
          this.formulario.preAberturaAssociado.outrasPartesDanificadas;
        this.checklistColisao =
          this.formulario.preAberturaAssociado.checklistColisao;
        this.fotosCondutor = this.formulario.preAberturaAssociado.fotosCondutor;
        this.fotosVeiculo = this.formulario.preAberturaAssociado.fotosVeiculo;
      } else if (this.dadosEvento.idEvento) {
        this.form = {
          ...this.form,
          idEvento: this.dadosEvento.idEvento,
          dadosCondutor: this.dadosEvento.dadosCondutor,
          pendenciaPreAbertura: this.dadosEvento.pendenciaPreAbertura,
          dataConsultaPatios: this.dadosEvento.dataConsultaPatios,
        };
        this.dadosCondutor = this.dadosEvento.dadosCondutor;
        this.dadosEnvolvidos = null;
        this.dadosTestemunhas = null;
        this.partesDanificadas = null;
        this.checklistColisao = null;
        this.outrasPartesDanificadas = this.dadosEvento.outrasPartesDanificadas;
      }
      this.dadosAssociado = this.dadosEvento.dadosAssociado;

      this.croqui = this.dadosEvento.croqui;
    },
    emitForm() {
      this.$emit('formAlterado', this.form);
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataStr(data) {
      var dia = data.split('/')[0];
      var mes = data.split('/')[1];
      var ano = data.split('/')[2];

      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
    },
    alteraFormularioDadosCondutor(dadosCondutor) {
      this.form.dadosCondutor = dadosCondutor;
    },
    alteraFormularioDadosCondutorFotos(fotosCondutor) {
      this.form.fotosCondutor = fotosCondutor;
    },
    alteraFormularioDadosVeiculoFotos(fotos) {
      this.form.fotosVeiculo = fotos;
    },
    alteraFormularioDadosEnvolvidos(dadosEnvolvidos) {
      this.form.dadosEnvolvidos = dadosEnvolvidos;

      this.atualizaCroqui(dadosEnvolvidos);
    },
    atualizaCroqui(dadosEnvolvidos) {
      const tiposVeiculosCounter = {
        1: 1,
        2: 1,
        3: 1,
      };
      const envolvidos = [
        {
          nome: 'Associado',
          codTipoVeiculo: this.dadosEvento.dadosVeiculo.codTipoVeiculo,
        },
        ...dadosEnvolvidos,
      ];

      this.envolvidosCroqui = envolvidos.map((envolvido, index) => {
        const data = {
          id: index,
          nome: envolvido.nome,
          src: `https://bboneapp.s3.amazonaws.com/imgsPadrao/imgEventos/${
            envolvido.codTipoVeiculo
          }/${tiposVeiculosCounter[envolvido.codTipoVeiculo]}.png`,
          codTipoVeiculo: envolvido.codTipoVeiculo,
        };

        tiposVeiculosCounter[envolvido.codTipoVeiculo]++;

        return data;
      });
    },
    alteraFormularioDadosTestemunhas(dadosTestemunhas) {
      this.form.dadosTestemunhas = dadosTestemunhas;
    },
    alteraFormularioPartesDanificadas({
      partesDanificadas,
      outrasPartesDanificadas,
    }) {
      this.form.partesDanificadas = partesDanificadas;
      this.form.outrasPartesDanificadas = outrasPartesDanificadas;
    },
    alteraFormularioChecklistColisao(checklistColisao) {
      this.form.checklistColisao = checklistColisao;
    },
  },
  mounted() {
    this.preencheForm();
    this.$validator.localize('ptBr', locale);
  },
  created: function () {
    this.$watch('form', this.emitForm, {
      deep: true,
    });
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.vx-row.divider {
  border: 0.5px solid rgba(0, 0, 0, 0.08);
}
</style>
